import { SupportedLanguagesType } from "@/constants/i18n"
import Button from "@/theme/variant/Button"
import Checkbox from "@/theme/variant/Checkbox"
import CssBaseline from "@/theme/variant/CssBaseline"
import IconButton from "@/theme/variant/IconButton"
import Paper from "@/theme/variant/Paper"
import Radio from "@/theme/variant/Radio"
import Select from "@/theme/variant/Select"
import Tabs, { Tab } from "@/theme/variant/Tabs"
import TextField from "@/theme/variant/TextField"
import TypographyAr from "@/theme/variant/TypographyAr"
import TypographyEn from "@/theme/variant/TypographyEn"
import { getCurrentLocale } from "@/util/i18n"
import { ThemeOptions } from "@mui/material"
import { CSSProperties } from "@mui/material/styles/createMixins"
import { TypographyOptions } from "@mui/material/styles/createTypography"

const typography: Record<SupportedLanguagesType, TypographyOptions> = {
  "en-GB": TypographyEn,
  "ar-SA": TypographyAr,
}

const proTheme: ThemeOptions = {
  palette: {
    mode: "light",
    theme: "pro",
    primary: {
      main: "#FFCB05",
      contrastText: "#1E1E1E",
    },
    secondary: {
      main: "#1E1E1E",
      contrastText: "#F7F7F7",
    },
    tertiary: {
      main: "#E0E0E0",
      light: "#E8E8E8",
      dark: "#BDBDBD",
      contrastText: "#1E1E1E",
    },
    kwalee: {
      main: "#ffcd05",
      light: "#ffd844",
      dark: "#ffc400",
      contrastText: "#1E1E1E",
    },
    background: {
      default: "#F2F3F7",
      paper: "#FFFFFF",
      card: "#FFFFFF",
      leftNav: "#F8F9FA",
      layout: "#F8F9FA",
    },
    bgSvgShade: {
      startColor: "#FFCD05",
      stopColor: "#FAA51A",
    },
    ctaSvgShade: {
      startColor: "#FFCD05",
      stopColor: "#FAA51A",
    },
  },
  typography: typography[getCurrentLocale() ?? "en-GB"],
  components: {
    MuiButton: Button,
    MuiCheckbox: Checkbox,
    MuiCssBaseline: CssBaseline,
    MuiIconButton: IconButton,
    MuiPaper: Paper,
    MuiRadio: Radio,
    MuiSelect: Select,
    MuiTabs: Tabs,
    MuiTab: Tab,
    MuiTextField: TextField,
  },
  mixins: {
    flex: ({
      justifyContent = "center",
      alignItems = "center",
      flexDirection = "row",
    }) =>
      ({
        display: "flex",
        justifyContent,
        alignItems,
        flexDirection,
      } as CSSProperties),
  },
}

export default proTheme
